import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const TOKEN_KEY = "invexting_token";
export const USER_KEY = "invexting_user";

export const api = axios.create({ baseURL: BACKEND_URL, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/api/auth/login")) {
      window.dispatchEvent(new CustomEvent("invexting:session-expired"));
    }
    return Promise.reject(error);
  }
);

export function apiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) return detail[0]?.msg || fallback;
  if (error?.code === "ECONNABORTED") return "Request timed out. Please check your connection.";
  return error?.message === "Network Error" ? "Cannot reach the server right now." : fallback;
}

/** Resolve a server-relative media path (e.g. /api/uploads/x.png) to an absolute URL. */
export function mediaUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}
